import {useState} from 'react';
import {useNavigate} from 'react-router';
import {Button} from '@ui/buttons/button';
import {SearchIcon} from '@ui/icons/material/Search';
import type {BlockInstance} from '../appearance-data';

/** Listings search block — submits the query to the configured listings page. */
export function SearchBlock({props}: {block: BlockInstance; props: Record<string, any>}) {
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const base = `/${props.target || 'opportunities'}`;
    const sep = base.includes('?') ? '&' : '?';
    navigate(q.trim() ? `${base}${sep}search=${encodeURIComponent(q.trim())}` : base);
  };

  return (
    <section className="px-24 py-56" style={{backgroundColor: props.bg_color || '#0b3d2e', color: props.text_color || '#fff'}}>
      <div className="mx-auto max-w-[820px] text-center">
        {props.heading ? <h2 className="text-2xl font-bold md:text-3xl">{props.heading}</h2> : null}
        {props.subheading ? <p className="mt-8 opacity-90">{props.subheading}</p> : null}
        <form onSubmit={submit} className="mx-auto mt-20 flex max-w-640 items-center gap-8 rounded-full bg-white p-6 shadow-lg">
          <SearchIcon className="ms-10 text-muted" />
          <input
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder={props.placeholder || 'Search…'}
            className="h-44 flex-1 border-0 bg-transparent px-4 text-sm text-black outline-none"
          />
          <Button type="submit" variant="flat" color="primary" className="rounded-full">
            {props.button_label || 'Search'}
          </Button>
        </form>
      </div>
    </section>
  );
}
